import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import Links from "../../../Links";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import MuiImage from "../../../../img/mui.png";

const MuiProjectSection = styled(ProjectSection)`
  background: linear-gradient(30deg, #000000 0%, #2e2e2e 50%, #686868 100%);
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: #ffeb3b;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto auto auto auto;
  }
`;

const LocalProjectDescription = styled.p`
  margin-bottom: var(--spacing-medium);
  font-size: var(--font-size-text-small);

  @media (min-width: 768px) {
    padding: var(--spacing-clear) var(--spacing-medium);
  }
`;

function Mui() {
  return (
    <MuiProjectSection>
      <ProjectTitle title="Muibook" tag="2025" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="HTML">
          <Icons type="html-small" />
        </Badge>
        <Badge small title="CSS">
          <Icons type="css-small" />
        </Badge>
        <Badge tooltip="large" small title="Web Components">
          <Icons type="web-components-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
      </ProjectSectionSkills>
      <LocalProjectDescription>
        <Links href="/case-studies#muibook" style={{ color: "#ffeb3b" }}>
          Muibook
        </Links>{" "}
        is the home of the MUI Design System <span style={{ opacity: 0.5 }}>(MichaelUI)</span>. Originally an experiment
        with native Web Components, it has evolved into a standalone library offering clean, composable patterns to help
        you write less code and build faster.
      </LocalProjectDescription>

      <ProjectDescription>
        The site includes a Quick-start App • NPM Components • AI-powered Playground • Figma UI Kit • Themeable Tokens •
        Technical Documentation • Coded Components with Embedded Accessibility • UX Guidelines powered by Guru Guides
      </ProjectDescription>

      <ButtonGroup>
        <Button href="https://muibook.com" target="_blank" color="white">
          Muibook
        </Button>
        <Button href="https://muibook.com/#/base-theme" target="_blank" color="white">
          Theming
        </Button>
        <Button href="https://muibook.com/#/muiplay" target="_blank" color="white">
          Muiplay
        </Button>
        <Button href="https://muibook.com/#/create-mui-app" target="_blank" color="white">
          Create-App
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={MuiImage} desktop />
    </MuiProjectSection>
  );
}

export default Mui;
